import { flatttenGroups } from '../../utils/objectUtils';
import { groupBy, toObject } from '../../utils/arrayUtils';
import { STATIC_STATUSES } from '../../constants/statuses';

export const workspaceStatusesSelector = (workspaceKey) => (state) =>
  workspaceKey ? state.statuses[workspaceKey].concat(STATIC_STATUSES) : null;

export const activeWorkspaceStatusesSelector = (workspaceKey) => (state) =>
  workspaceKey
    ? state.statuses[workspaceKey]
        ?.filter((status) => !status.disabled)
        .concat(STATIC_STATUSES)
    : null;

export const statusSelector = (workspaceKey, statusKey) => (state) => {
  if (!Boolean(workspaceKey) || !Boolean(statusKey)) {
    return null;
  }

  return state.statuses[workspaceKey]
    ?.concat(STATIC_STATUSES)
    .find((t) => t.sk === statusKey);
};
